import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Table } from 'reactstrap';
import { Translate, TextFormat, getSortState, JhiPagination, JhiItemCount, ValidatedField, openFile, byteSize } from 'react-jhipster';
//import { JhiItemCount, JhiPagination, TextFormat, Translate, byteSize, getPaginationState, openFile } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { APP_DATE_FORMAT } from 'app/config/constants';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities } from './advertisment.reducer';

export const Advertisment = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getSortState(location, ITEMS_PER_PAGE, 'id'), location.search)
  );
  

  const advertismentList = useAppSelector(state => state.advertisment.entities);
  const loading = useAppSelector(state => state.advertisment.loading);
  const totalItems = useAppSelector(state => state.advertisment.totalItems);

  const getAllEntities = () => {
    dispatch(
      getEntities({
        page: paginationState.activePage - 1,
        size: paginationState.itemsPerPage,
        sort: `${paginationState.sort},${paginationState.order}`,
      }),
    );
  };

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="advertisment-heading" data-cy="AdvertismentHeading">
        <Translate contentKey="activitiesApp.advertisment.home.title">Advertisments</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="activitiesApp.advertisment.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to="/advertisment/new" className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="activitiesApp.advertisment.home.createLabel">Create new Advertisment</Translate>
          </Link>
        </div>
      </h2>
      <div className="table-responsive">
        {advertismentList && advertismentList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="activitiesApp.advertisment.id">ID</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('fromDate')}>
                  <Translate contentKey="activitiesApp.advertisment.fromDate">From Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('fromDate')} />
                </th>
                <th className="hand" onClick={sort('toDate')}>
                  <Translate contentKey="activitiesApp.advertisment.toDate">To Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('toDate')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="activitiesApp.advertisment.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('imageurl')}>
                  <Translate contentKey="activitiesApp.advertisment.imageurl">Imageurl</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('imageurl')} />
                </th>
                <th className="hand" onClick={sort('activityType')}>
                  <Translate contentKey="activitiesApp.advertisment.activityType">Activity Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('activityType')} />
                </th>
                <th className="hand" onClick={sort('description')}>
                  <Translate contentKey="activitiesApp.advertisment.description">Description</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('description')} />
                </th>
                <th className="hand" onClick={sort('advertismentImage')}>
                  <Translate contentKey="activitiesApp.advertisment.advertismentImage">Advertisment Image</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('advertismentImage')} />
                </th>
                <th>
                  <Translate contentKey="activitiesApp.advertisment.city">City</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {advertismentList.map((advertisment, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/advertisment/${advertisment.id}`} color="link" size="sm">
                      {advertisment.id}
                    </Button>
                  </td>
                  <td>
                    {advertisment.fromDate ? <TextFormat type="date" value={advertisment.fromDate} format={APP_DATE_FORMAT} /> : null}
                  </td>
                  <td>{advertisment.toDate ? <TextFormat type="date" value={advertisment.toDate} format={APP_DATE_FORMAT} /> : null}</td>
                  <td>{advertisment.active ? 'true' : 'false'}</td>
                  <td>{advertisment.imageurl}</td>
                  <td>
                    <Translate contentKey={`activitiesApp.ActivityType.${advertisment.activityType}`} />
                  </td>
                  <td>{advertisment.description}</td>
                  <td>
                    {advertisment.advertismentImage ? (
                      <div>
                        {advertisment.advertismentImageContentType ? (
                          <a onClick={openFile(advertisment.advertismentImageContentType, advertisment.advertismentImage)}>
                            <img
                              src={`data:${advertisment.advertismentImageContentType};base64,${advertisment.advertismentImage}`}
                              style={{ maxHeight: '30px' }}
                            />
                            &nbsp;
                          </a>
                        ) : null}
                        <span>
                          {advertisment.advertismentImageContentType}, {byteSize(advertisment.advertismentImage)}
                        </span>
                      </div>
                    ) : null}
                  </td>
                  <td>{advertisment.city ? <Link to={`/city/${advertisment.city.id}`}>{advertisment.city.cityName}</Link> : ''}</td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`/advertisment/${advertisment.id}`} color="info" size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/advertisment/${advertisment.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/advertisment/${advertisment.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="activitiesApp.advertisment.home.notFound">No Advertisments found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={advertismentList && advertismentList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default Advertisment;
